// extracted by mini-css-extract-plugin
export default {"loadingText":"Skeleton_loadingText__4uw0Y"};